import React, { useState, useEffect, useRef } from 'react';
import './MartialTournament.css';
import { MartialStyles } from './MartialOpponentAI';

function MartialTournament({ userData, onStartFight, onBack }) {
  const [progress, setProgress] = useState(0);
  const [paid, setPaid] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showNoCoins, setShowNoCoins] = useState(false);
  const audioRef = useRef(null);

  useEffect(() => {
    const init = async () => {
      try {
        const token = localStorage.getItem('token');
        const res = await fetch(`${process.env.REACT_APP_API_URL}/profile/martial-tournament`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        const data = await res.json();
        setProgress(data.progress || 0);

        if (data.paid) {
          setPaid(true);
          setLoading(false);
        } else {
          // Cobrar entrada
          const payRes = await fetch(`${process.env.REACT_APP_API_URL}/profile/martial-tournament/pay`, {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${token}` }
          });
          if (payRes.ok) {
            setPaid(true);
          } else {
            setShowNoCoins(true);
          }
          setLoading(false);
        }
      } catch (e) {
        setShowNoCoins(true);
        setLoading(false);
      }

      if (audioRef.current) {
        audioRef.current.volume = 0.3;
        audioRef.current.play().catch(() => {});
      }
    };
    init();
    return () => { if (audioRef.current) { audioRef.current.pause(); } };
  }, []);

  const handleFightClick = async (index) => {
    if (index > progress) return;
    localStorage.setItem('martialFightIndex', index.toString());
    onStartFight(index);
  };

  if (loading) return null;

  if (showNoCoins) {
    return (
      <div className="martial-tournament" style={{ backgroundImage: "url('/img/backgroundtorneomarcial.png')" }}>
        <div className="mt-modal-overlay">
          <div className="mt-modal">
            <div className="mt-modal-icon">💰</div>
            <h2>Monedas Insuficientes</h2>
            <p>Necesitás 100 monedas para entrar al torneo.</p>
            <p className="mt-modal-coins">Tus monedas: {userData?.monedas || 0}</p>
            <button className="mt-modal-btn" onClick={onBack}>ENTENDIDO</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="martial-tournament" style={{ backgroundImage: "url('/img/backgroundtorneomarcial.png')" }}>
      <audio ref={audioRef} src="/audio/taekwondomaster.mp3" loop />
      
      <div className="mt-header">
        <button className="mt-back-btn" onClick={onBack}>← VOLVER</button>
        <h1 className="mt-title">⚔️ TORNEO MARCIAL</h1>
        <div className="mt-coins">💰 {userData?.monedas || 0}</div>
      </div>

      <p className="mt-subtitle">Derrotá a cada estilo para avanzar al siguiente</p>

      <div className="mt-bracket">
        {MartialStyles.map((style, index) => {
          const isUnlocked = index <= progress;
          const isCompleted = index < progress;
          
          return (
            <div
              key={style.id}
              className={`mt-fighter ${isUnlocked ? 'unlocked' : 'locked'} ${isCompleted ? 'completed' : ''}`}
              onClick={() => handleFightClick(index)}
            >
              <div className="mt-fighter-number">{index + 1}</div>
              <img
                src={`/torneomartiarl/${style.folder}/presentacion.png`}
                alt={style.name}
                className="mt-fighter-img"
              />
              <div className="mt-fighter-name">{style.name}</div>
              {isCompleted && <div className="mt-check">✓</div>}
              {!isUnlocked && <div className="mt-lock">🔒</div>}
              {index < MartialStyles.length - 1 && <div className="mt-connector" />}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default MartialTournament;
